export default {
  frame: '#673AB7',
  system: '#489928',
  protocol: '#1b6361',
  mod: '#0b9e8a',
  structure: '#443FFF',
  hp: '#0284FF',
  armor: '#82B1FF',
  overshield: '#82B1FF',
  heat: '#FF7043',
  stress: '#FF3D00',
  heatcap: '#EF5350',
  core: '#D4E157',
  dangerzone: '#FF1744',
  overcharge: '#F50057',
  tech: '#007674',
  reaction: '#512DA8',
  skill: '#524f3b',
  deployable: '#47525C',

  reserve: '#00695C',

  // actions
  'action--move': '#C62828',
  'action--full': '#283593',
  'action--jockey': '#283593',
  'action--quick': '#3949AB',
  'action--overcharge': '#F50057',
  'action--free': '#00695C',
  'action--protocol': '#007676',
  'action--tech': '#802475',
  'action--invade': '#802475',

  // damage types
  'damage--kinetic': '#757575',
  'damage--energy': '#29B6F6',
  'damage--explosive': '#FFA726',
  'damage--burn': '#B71C1C',
  'damage--heat': '#FF7043',
  'damage--variable': '#D500F9',

  // npc colors
  'npc--passive': '#991E2A',
  'npc--action': '#5CB338',
  'npc--tech': '#802475',
  'npc--protocol': '#FF9149',
  'npc--reaction': '#006A71',
  'npc--weapon': '#222222',

  'role--striker': '#bd3f39',
  'role--defender': '#d67e08',
  'role--controller': '#398ad6',
  'role--support': '#6aa84f',
  'role--artillery': '#a64d79',
  'role--biological': '#7e52a3',

  enemy: '#C62828',
  ally: '#1661b8',
  neutral: '#455A64',

  // brand colors
  patreon: '#FF424D',
  itch: '#fa5c5c',

  // UI Overrides
  background: '#f4f4f4',
}
